import { Box, Typography, useTheme } from "@mui/material";
import React, { ForwardedRef, forwardRef, useState } from "react";
import PlusMiniSvg from "../../../../../../media/images/icons/plus-mini";
import ArrowTickDown from "../../../../../../media/images/icons/arrow-tick-down";
import { addCommas } from "@persian-tools/persian-tools";
import { ITransaction } from "../../../../../../types/wallet";
import { blueGrey } from "@mui/material/colors";
import NegetiveMiniSVG from "../../../../../../media/images/icons/negetive-icon";

const TransactionCard = forwardRef(
  (props: ITransaction, ref: ForwardedRef<HTMLDivElement>) => {
    const {
      amount,
      status,
      statusDesc,
      insertDate,
      insertTime,
      code,
      payerCode,
    } = props;

    const theme = useTheme();
    const [open, setOpen] = useState(false);

    return (
      <Box
        ref={ref}
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.05)",
          borderRadius: "16px",
          backgroundColor: theme.palette.bgColor.grey100,
          padding: "8px 8px",
          borderColor: blueGrey[100],
          borderWidth: "1px",
          borderStyle: open ? "solid" : "",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {!(status === 1001) ? (
              <PlusMiniSvg size={28} color={theme.palette.success.main} />
            ) : (
              <NegetiveMiniSVG size={30} color={theme.palette.error.main} />
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  color: status === 1001 ? "error.main" : "success.main",
                  fontSize: "14px",
                }}
              >
                {statusDesc}
              </Typography>
              <Typography
                sx={{
                  fontSize: "12px",
                }}
              >
                {insertDate} - {insertTime}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "end",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: status === 1001 ? "error.main" : "success.main",
                }}
              >
                {addCommas(amount)} ریال
              </Typography>
              <Typography
                sx={{
                  fontSize: "11px",
                }}
              >
                {/* موجودی نهایی: {digitsEnToFa(addCommas(200000))} ریال */}
              </Typography>
            </Box>
            <Box
              sx={{
                rotate: open ? "180deg" : "0deg",
                transition: "all 0.3s",
              }}
            >
              <ArrowTickDown color={theme.palette.info.dark} size={12} />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            height: open ? "140px" : "0px",
            borderRadius: "16px",
            overflow: "hidden",
            transition: "all 0.3s",
            mt: 1,
            backgroundColor: "bgColor.white",
            paddingX: "8px",
          }}
        >
          <Box
            sx={{
              my: 1,
              backgroundColor: "background.default",
              mx: "auto",
              borderRadius: "8px",
              py: "8px",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "primary.main",
                textAlign: "center",
              }}
            >
              شماره رهگیری: {code}
            </Typography>
          </Box>
          <Box
            sx={{ mt: 2, display: "flex", flexDirection: "column", gap: "4px" }}
          >
            {/* <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  color: "primary.main",
                }}
              >
                شماره کارت:
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "primary.main",
                }}
              >
                {digitsEnToFa(6219621962196219)}
              </Typography>
            </Box> */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  color: "primary.main",
                  fontSize: "14px",
                }}
              >
                تاریخ:{" "}
              </Typography>
              <Typography
                sx={{
                  color: "primary.main",
                  fontSize: "14px",
                }}
              >
                {insertDate} - {insertTime}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  color: "primary.main",
                  fontSize: "14px",
                }}
              >
                شماره هوشمند وسیله نقلیه:{" "}
              </Typography>
              <Typography
                sx={{
                  color: "primary.main",
                  fontSize: "14px",
                }}
              >
                {payerCode}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  color: "primary.main",
                  fontSize: "14px",
                }}
              >
                روش پرداخت:{" "}
              </Typography>
              <Typography
                sx={{
                  color: "primary.main",
                  fontSize: "14px",
                }}
              >
                بانک سامان - کارت بانکی
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
);

export default TransactionCard;
